var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.258423,
    y: 0.775269,
    width: 24.9438,
    height: 24.9438,
    rx: 12.4719,
    fill: "#828282"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5194 4.12734C12.6957 3.98148 12.9507 3.98148 13.127 4.12734L20.8645 10.5304C21.0193 10.6585 21.0771 10.8699 21.009 11.0589C20.9409 11.248 20.7616 11.374 20.5607 11.374H19.4545V20.775H20.4869C20.7501 20.775 20.9634 20.9884 20.9634 21.2516C20.9634 21.5147 20.7501 21.7281 20.4869 21.7281H5.15935C4.89618 21.7281 4.68285 21.5147 4.68285 21.2516C4.68285 20.9884 4.89618 20.775 5.15935 20.775H6.19183V11.374H5.08575C4.88483 11.374 4.7055 11.248 4.63743 11.0589C4.56936 10.8699 4.62717 10.6585 4.78196 10.5304L6.19183 9.36365V4.49445C6.19183 4.23128 6.40517 4.01794 6.66834 4.01794H9.05086C9.31403 4.01794 9.52736 4.23128 9.52736 4.49445V6.60338L12.5194 4.12734ZM6.40897 10.421H19.2375L12.8232 5.11295L6.40897 10.421ZM7.14484 8.57497V4.97095H8.57435V7.392L7.14484 8.57497ZM7.14484 11.3837V20.755H10.1625V15.8114C10.1625 15.5482 10.3759 15.3349 10.639 15.3349H15.2055C15.4687 15.3349 15.6821 15.5482 15.6821 15.8114V20.755H18.5015V11.3837H7.14484ZM11.1156 16.2879V20.6956H14.729V16.2879H11.1156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumo);
export default __webpack_public_path__ + "static/media/consumo.58a59b70cbda0231bed961f329166fd6.svg";
export { ForwardRef as ReactComponent };